'use client'
import { Button } from '@heroui/button'
import { Input } from '@heroui/input'
import { InputOtp } from '@heroui/input-otp'
import {
  Modal,
  ModalHeader,
  ModalContent,
  useDisclosure,
  ModalBody,
  ModalFooter,
} from '@heroui/modal'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

import { Typography } from '@/components/ui'
import { authClient } from '@/lib/auth-client'
import { routes } from '@/routes'

export const OtpForm = () => {
  const [email, setEmail] = useState('')
  const router = useRouter()
  const [otp, setOtp] = useState('')
  const { isOpen, onOpen, onClose } = useDisclosure()

  const handleContinueWithEmail = async () => {
    const { error } = await authClient.emailOtp.sendVerificationOtp({
      email,
      type: 'sign-in',
    })
    if (error) {
      console.error(error)
    }
    onOpen()
  }

  const handleVerifyOtp = async () => {
    const { data, error } = await authClient.signIn.emailOtp({
      email,
      otp,
    })
    if (data) {
      router.refresh()
    }
    if (error) {
      console.error(error)
    }
  }

  return (
    <>
      <div className="mb-4 flex w-full max-w-[329px] flex-col justify-center gap-2">
        <Input
          placeholder="Email"
          className="w-full"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button
          variant="faded"
          color="primary"
          size="lg"
          radius="full"
          onPress={handleContinueWithEmail}
        >
          Continue with Email
        </Button>
      </div>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalContent>
          <ModalHeader>Enter OTP</ModalHeader>
          <ModalBody>
            <Typography className="mb-2 text-small text-default-500">
              6 digits OTP
            </Typography>
            <InputOtp length={6} value={otp} onValueChange={setOtp} />
          </ModalBody>
          <ModalFooter>
            <Button onPress={handleVerifyOtp}>Verify</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
